import { render, staticRenderFns } from "./SettingAccountRegister.vue?vue&type=template&id=9cf24280"
import script from "./SettingAccountRegister.vue?vue&type=script&lang=js"
export * from "./SettingAccountRegister.vue?vue&type=script&lang=js"
import style0 from "./SettingAccountRegister.vue?vue&type=style&index=0&id=9cf24280&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports